import { useEffect } from "react";

export function useAppViewportHeight() {
  useEffect(() => {
    const set = () => {
      const vh = window.innerHeight;
      document.documentElement.style.setProperty("--app-dvh", `${vh}px`);
    };
    set();
    window.addEventListener("resize", set);
    window.addEventListener("orientationchange", set);
    return () => {
      window.removeEventListener("resize", set);
      window.removeEventListener("orientationchange", set);
    };
  }, []);
}
